<template>
  <div class="content">
    <!-- 没有数据 占位图 -->
    <div v-if="noData" class="nowzb-wrapper">
      <div class="nowzb-wrap_img" v-if="showNo">
        <img src="../../assets/images/noParty.png" @click="showNo=false" />
      </div>
    </div>
    <!-- 有数据 展示轮播列表-->
    <!-- 微支部轮播 -->
    <Carousel
      class="carousel-wrap"
      v-else
      v-model="startInd"
      :height="Height"
      arrow="always"
      @on-change="changeInd"
    >
      <CarouselItem class="carousel-item" v-for="(item, index) in orgList" :key="index">
        <!------------------- 大党委 两代表一委员 ------------------->
        <section class="ddw-ldb-wrap" v-if="item.type==='first' ">
          <!-- 大党委标题 -->
          <header class="ddw-ldb-header ddw-header">{{item.ddw.zoneName}}</header>
          <!-- 大党委 -->
          <div class="ddw-wrap">
            <!-- 书记 -->
            <div class="ddw-shuji">
              <span class="ddw-title">{{item.ddw.shuji.name}}</span>
              <bk-person
                class="ddw-person"
                v-for="shuji in item.ddw.shuji.value"
                :key="shuji.id"
                :editable="false"
                :showPhone="false"
                :nameFontSize="24"
                :jobFontSize="18"
                :user="shuji"
              ></bk-person>
            </div>
            <!-- 专职委员 -->
            <div class="ddw-zhuanzhi">
              <span class="ddw-title">{{item.ddw.zhuanzhi.name}}</span>
              <bk-person
                class="ddw-person"
                v-for="zhuanzhi in item.ddw.zhuanzhi.value"
                :key="zhuanzhi.id"
                :editable="false"
                :showPhone="false"
                :nameFontSize="24"
                :jobFontSize="18"
                :user="zhuanzhi"
              ></bk-person>
            </div>
            <!-- 兼职委员 -->
            <div class="ddw-jianzhi">
              <span class="ddw-title">{{item.ddw.jianzhi.name}}</span>
              <bk-person
                class="ddw-person"
                v-for="jianzhi in item.ddw.jianzhi.value"
                :key="jianzhi.id"
                :editable="false"
                :showPhone="false"
                :nameFontSize="24"
                :jobFontSize="18"
                :user="jianzhi"
              ></bk-person>
            </div>
          </div>
          <!-- 两代表一委员标题 -->
          <header class="ddw-ldb-header ldb-header">{{item.ldb.zoneName}}</header>
          <!-- 两代表一委员 -->
          <div class="ldb-wrap">
            <bk-person
              class="ddw-person"
              v-for="ldbPerson in item.ldb.personList"
              :key="ldbPerson.id"
              :editable="false"
              :showPhone="false"
              :nameFontSize="24"
              :jobFontSize="18"
              :user="ldbPerson"
            ></bk-person>
          </div>
        </section>
        <!------------------- 社区党总支 ------------------->
        <section class="dzz-wrap" v-else-if="item.type === 'second'">
          <!-- 标题 -->
          <div class="dzz-header">
            <img class="dzz-header_img" src="@/assets/images/partyDetail/flag.png" />
            <div class="dzz-title">{{item.zoneName}}</div>
          </div>
          <!-- 党总支简介以及二维码 -->
          <div class="dzz-brief-wrap">
            <!-- 简介的标题 -->
            <div class="dzz-brief_title">社区党总支简介</div>
            <!-- 简介的内容 -->
            <div class="dzz-brief_content">{{item.remark}}</div>
            <!-- 二维码 -->
            <img class="dzz-brief_qrcode" v-if="item.qrcodeUrl" :src="item.qrcodeUrl" />
          </div>
          <!-- 党总支成员 支部书记/其他成员 -->
          <div class="dzz-member-wrap">
            <!-- 标题 -->
            <div class="dzz-member_title">党总支成员</div>
            <!-- 成员 -->
            <div class="dzz-member">
              <!-- 书记 -->
              <div class="dzz-member_shuji">
                <div class="dzz-member_shuji-title">{{item.dzz.shuji.name}}</div>
                <bk-person
                  class="ddw-person"
                  v-for="shuji in item.dzz.shuji.value"
                  :key="shuji.id"
                  :editable="false"
                  :showPhone="false"
                  :nameFontSize="24"
                  :jobFontSize="18"
                  :user="shuji"
                ></bk-person>
              </div>
              <!-- 其他委员 -->
              <div class="dzz-member_other">
                <div class="dzz-member_shuji-title">{{item.dzz.other.name}}</div>
                <bk-person
                  class="ddw-person"
                  v-for="other in item.dzz.other.value"
                  :key="other.id"
                  :editable="false"
                  :showPhone="false"
                  :nameFontSize="24"
                  :jobFontSize="18"
                  :user="other"
                ></bk-person>
              </div>
            </div>
          </div>
          <!-- 分支部 -->
          <div class="dzz-branch-wrap">
            <!-- 标题 -->
            <div class="dzz-branch_title">其他自管党支部（{{item.branch.count}}个）</div>
            <!-- 分支部列表 -->
            <div class="dzz-branch_list">
              <div class="dzz-branch_list-item" v-for="branch in item.branch.list" :key="branch.id">
                <div class="dzz-branch_list-item_title">{{branch.zoneName}}</div>
                <img class="dzz-branch_list-item_img" :src="branch.cover" />
              </div>
            </div>
          </div>
        </section>
        <!------------------- 一般微支部 ------------------->
        <div class="wzb-wrapper" v-else>
          <!--微支部头部-->
          <div class="wzb-header">
            <img class="wzb-header_img" src="@/assets/images/partyDetail/flag.png" />
            <div class="wzb-title">{{item.zoneName}}</div>
          </div>
          <div class="wzb-body" v-if="item.hasData">
            <!--//微支部主体-->
            <wzb-left
              class="wzh-left"
              :height="Height"
              :width="Width"
              :info="item.info"
              :leftScroll="item.leftScroll"
            ></wzb-left>
            <wzb-mid
              class="wzb-mid"
              :height="Height"
              :width="Width"
              :leader="item.leader"
              :huodongNumber="item.huodongNumber"
              :qiandaoNumber="item.qiandaoNumber"
              :activityPicList="item.activityPicList"
              :index="index"
              :nowIndex="nowIndex"
            ></wzb-mid>
            <wzb-right
              class="wzb-right"
              :height="Height"
              :width="Width"
              :partyActive="item.partyActive"
              :baomingMember="item.baomingMember"
            ></wzb-right>
          </div>
        </div>
      </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
var that;
import wzbLeft from "./components/wzbLeft";
import wzbRight from "./components/wzbRight";
import wzbMid from "./components/wzbMiddle";
import bkPerson from "./components/person";

export default {
  inject: ["reload"],
  components: {
    wzbLeft,
    wzbRight,
    wzbMid,
    bkPerson
  },
  data() {
    return {
      curOrgId: "",
      Height: window.document.body.offsetHeight - 60,
      Width: window.document.body.offsetWidth,
      orgList: [],
      nowIndex: 0, //当前页面Index,
      startInd: 0, // 默认起始微支部索引

      noData: false,
      showNo: true
    };
  },
  watch: {
    curOrgId(val) {
      // 社区id更新 请求列表
      this.getList();
    }
  },
  computed: {},
  activated() {
    this.curOrgId = this.$route.query.communityId;
  },
  created() {},
  mounted: function() {
    that = this;
    this.Height = window.document.body.offsetHeight - 60;
    this.Width = window.document.body.offsetWidth;
  },
  methods: {
    /* 获取列表 包括大党委和党总支 和微支部列表 */
    getList() {
      let lists = [
        this.getFirstData(),
        this.getSecondData(),
        this.getWzbList()
      ];
      this.$showLoading();
      Promise.all(lists)
        .then(res => {
          let [first, second, wzbList] = res;
          // 弹出错误信息
          if (!first.isSucceed || !second.isSucceed || !wzbList.isSucceed) {
            return this.$Message.error(
              first.message || second.message || wzbList.message
            );
          }

          /* 第一个轮播数据 */
          let [ddw, ldb] = first.rows;

          let firstData = {
            type: "first",
            ddw: {
              zoneName: ddw.zoneName,
              shuji: {},
              zhuanzhi: {},
              jianzhi: {}
            },
            ldb: {
              zoneName: ldb.zoneName,
              personList: Object.keys(ldb.userMapList).reduce((pre, cur) => {
                pre.push(...ldb.userMapList[cur]);
                return pre;
              }, [])
            }
          };
          // 按照索引遍历数据
          let _point = [
            firstData.ddw.shuji,
            firstData.ddw.zhuanzhi,
            firstData.ddw.jianzhi
          ];
          Object.keys(ddw.userMapList).forEach((item, index) => {
            if (!_point[index]) return;
            _point[index].name = item;
            _point[index].value = ddw.userMapList[item] || [];
          });

          /* 第二个轮播数据 */
          let _dzz = second.rows[0],
            _branch = second.newPrimaryKeys;

          let secondData = {
            type: "second",
            zoneName: _dzz.zoneName,
            remark: _dzz.remark,
            qrcodeUrl: _dzz.qrcodeUrl,
            dzz: {
              shuji: {},
              other: {}
            },
            branch: {
              count: _branch.otherPartyCount || 0,
              // 只显示前三个
              list: _branch.otherParty.slice(0, 3).map(item => {
                return {
                  id: item.id,
                  zoneName: item.zoneName,
                  cover: item.picList.length ? item.picList[0].picPath : ""
                };
              })
            }
          };
          // 按索引去数据
          _point = [secondData.dzz.shuji, secondData.dzz.other];
          Object.keys(_dzz.userMapList).forEach((item, index) => {
            if (!_point[index]) return;
            _point[index].name = item;
            _point[index].value = _dzz.userMapList[item] || [];
          });

          /* 一般支部数据 */
          let zone = wzbList.rows.map(item => {
            return {
              type: "zone",
              id: item.zoneId,
              zoneName: item.zoneName,
              hasData: false
            };
          });

          this.orgList = [firstData, secondData, ...zone];
        })
        .catch(e => console.log(e))
        .finally(this.$hideLoading);
    },
    /* 获取第一个轮播的数据 */
    getFirstData() {
      let url = this.urlobj.partyOne;
      return this.$get(url, {
        communityId: this.curOrgId
      });
    },
    /* 获取第二个轮播数据 */
    getSecondData() {
      let url = this.urlobj.partyTwo;
      return this.$get(url, {
        communityId: this.curOrgId
      });
    },
    /* 获取微支部列表 */
    getWzbList() {
      var url = this.urlobj.getOrg();
      return this.$get(url, {
        communityId: this.curOrgId,
        zoneType: 2,
        isRemoveCommunityParty:1
      });
    },
    /* 获取微支部信息和活动信息 */
    promiseData(id) {
      let getSqDetail = that.getSqDetail(id);
      let getEvent = that.getEvent(id);

      let cur = this.orgList[this.nowIndex];

      this.$showLoading();
      Promise.all([getSqDetail, getEvent])
        .then(res => {
          if (!res[0].isSucceed || !res[1].isSucceed)
            return this.$Message.error(res[0].message || res[1].message);
          // 修改当前表示
          cur.hasData = true;
          //处理getSqDetail的数据
          let _t = res[0].rows[0];
          // 初始化info
          cur.info = {
            totalNumber: _t.info.totalNumber,
            zoneName: _t.info.zoneName,
            qrcodeUrl: _t.info.qrcodeUrl
          };
          // 初始化图片
          var imgArr = _t.pic.map(item => {
            return { img: item.picPath };
          });
          cur.leftScroll = [
            { text: _t.info.remark ? _t.info.remark : "" }
          ].concat(imgArr);

          // 委员列表 保留原字段
          cur.leader = Object.keys(_t.userMapList)
            .reduce((pre, cur) => {
              pre.push(..._t.userMapList[cur]);
              return pre;
            }, [])
            .map(item => {
              return {
                key: item.id,
                headPicUrl: item.headPicUrl,
                realName: item.userName,
                proTitle: item.proTitle
              };
            });

          //活动 签到数量
          cur.huodongNumber = _t.activityCount.activityCount;
          cur.qiandaoNumber = _t.activityCount.signCount;

          //处理getEvent 的数据
          var data = res[1];

          if (data.rows.length) {
            cur.activityPicList = data.rows[0].activityPicList;
            var req = data.rows[0].detail;
            cur.partyActive = {
              title: req.title,
              baoming: req.applyNumber,
              pinglun: req.messageNumber,
              chakan: req.previewNumber,
              cover: req.coverPicUrl
            };
            cur.baomingMember = data.rows[0].applyUserList
              .splice(0, 4)
              .map(item => {
                return {
                  pic: item.headPicUrl,
                  name: item.userName,
                  time:
                    typeof item.recordTime == "string"
                      ? item.recordTime
                      : that.$util.FormatDate(
                          Number(item.recordTime),
                          "MM-dd  HH:mm"
                        )
                };
              });
          } else {
            cur.partyActive = {
              title: "",
              baoming: "",
              pinglun: "",
              chakan: "",
              cover: ""
            };
            cur.baomingMember = [];
            cur.activityPicList = [];
          }
        })
        .finally(this.$hideLoading);
    },
    /* 获取微支部信息 */
    getSqDetail(id) {
      let url = this.urlobj.zoneInfo(id);
      return this.$get(url, {
        queryType: "info,pic,activityCount,userMapList"
      });
    },
    /* 微支部事件 */
    getEvent(id) {
      var url = this.urlobj.getPartyActive;
      return this.$get(url, {
        zoneId: id
      });
    },
    changeInd(oldValue, value) {
      this.nowIndex = value;
      let cur = this.orgList[value];
      // 微支部类型 且没有数据时请求
      if (cur.type === "zone" && !cur.hasData) {
        this.promiseData(cur.id);
      }
    }
  }
};
</script>

<style scoped lang="less">
@contentHeight: calc(100vh - 60px);
@wzbTitle: 0.55rem;
@wzbTitlePadding: 0.3rem;
.carousel-btn-pre {
  // 预留轮播组建左右按钮空间
  padding-left: 60px;
  padding-right: 60px;
  padding-bottom: 2rem; // 底部预留空间 防止文字于背景图上看不清
}

.ddw-ldb-wrap {
  .flex(center, @flexDirection:column);
  box-sizing: border-box;
  min-height: @contentHeight;
  padding-top: 1rem;
  .carousel-btn-pre();
}

/* 带旗子的标题 */
.ddw-ldb-header {
  position: relative;
  font-size: 0.36rem;
  color: #4b4b4b;
  font-weight: bolder;
  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: calc(-0.6rem - 0.2rem);
    background: url("~@/assets/images/partyDetail/org-admin-icon.png");
    background-size: 100%;
    height: 0.32rem;
    width: 0.6rem;
    transform: translateY(-50%);
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    right: calc(-0.6rem - 0.2rem);
    background: url("~@/assets/images/partyDetail/org-admin-icon.png");
    background-size: 100%;
    height: 0.32rem;
    width: 0.6rem;
    transform: rotateY(180deg) translateY(-50%);
  }
}
// 大党委
.ddw-wrap,
.ldb-wrap {
  .flex(flex-start);
}
.ddw-wrap {
  margin-top: 0.8rem;
  margin-bottom: 0.4rem;
}
.ldb-wrap {
  margin-top: 0.4rem;
}
.ddw-shuji,
.ddw-zhuanzhi,
.ddw-jianzhi {
  .flex(flex-start, @flexWrap:wrap);
  position: relative;
}
.ddw-shuji {
  margin-right: 1.3rem;
}
.ddw-person {
  margin: 0.2rem;
}
.ddw-zhuanzhi {
  margin-right: 1rem;
}
.ddw-title {
  position: absolute;
  left: 0;
  top: -2em;
  font-size: 0.24rem;
  color: #666;
  white-space: nowrap;
}
/* 党总支 */
.dzz-wrap {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: auto minmax(1rem, auto);
  grid-template-areas:
    "hd hd"
    "sd ct"
    "sd cb";
  grid-gap: 0.2rem 0.5rem;

  margin-top: 0.2rem;
  .carousel-btn-pre();
}
.dzz-header {
  grid-area: hd;
  .flex(center, center);
}
.dzz-brief-wrap {
  grid-area: sd;
  justify-self: center;
  text-align: center;
}
.dzz-brief_title,
.dzz-member_title,
.dzz-branch_title {
  color: #4b4b4b;
  font-size: 0.3rem;
  font-weight: bold;
  margin-bottom: 0.2rem;
  text-align: center;
}
.dzz-brief_content {
  .ellipsisLn(5);
  height: 300px; // 为了与一般微支部简介高度一致
  color: #333;
  font-size: 0.26rem;
  line-height: 2em;
  text-align: left;
  margin-bottom: 0.2rem;
}
.dzz-brief_qrcode {
  width: 2rem;
  height: 2rem;
}
.dzz-member-wrap {
  grid-area: ct;
}
.dzz-member {
  .flex(flex-start);
}
.dzz-member_shuji {
  .flex(flex-start);
  min-width: 3rem;
}
.dzz-member_shuji-title {
  font-size: 0.26rem;
  color: #666;
}
.dzz-member_other {
  .flex(flex-start, @flexWrap:wrap);
}
.dzz-branch-wrap {
  grid-area: cb;
}
.dzz-branch_list {
  .flex(flex-start);
}
.dzz-branch_list-item {
  flex: 1;
  margin-right: 0.4rem;
  &:last-child {
    margin-right: 0;
  }
}
.dzz-branch_list-item_title {
  font-size: 0.26rem;
  color: #666;
  margin-bottom: 30px;
}
.dzz-branch_list-item_img {
  width: 100%;
  max-width: 3rem;
  height: auto;
}

.content {
  position: relative;
  min-height: @contentHeight;
  background-image: url("../../assets/staticsPic/bc.png");
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.nowzb-wrap_img {
  .flex(center, center);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
}
/* 轮播 */
.carousel-wrap {
  height: @contentHeight;
}
.carousel-item {
  overflow-y: scroll;

  .noIEScrollBar();
  scrollbar-width: 0;
  &::-webkit-scrollbar {
    display: none;
  }
}
.wzb-wrapper {
  .flex(center, @flexDirection:column);
  position: relative;
  .carousel-btn-pre();
}
.wzb-header {
  .flex(center);
  margin: @wzbTitlePadding 0;
}
.wzb-body {
  flex: 1;
  .flex(flex-start);
  width: 100%;
  margin-bottom: 20px; // 预留轮播组建底部高度
}
.wzb-header_img,
.dzz-header_img {
  width: 0.8rem;
  height: 0.9rem;
}
.wzb-title,
.dzz-title {
  color: transparent;
  font-size: @wzbTitle;
  font-family: "KaiTi";
  background-image: url("../../assets/images/partyDetail/orgTitleBg.jpg");
  background-repeat: repeat-x;
  -webkit-background-clip: text;

  white-space: nowrap;
  max-width: 1000px;
  overflow: hidden;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.wzb-left,
.wzb-right {
  flex: 1;
  min-width: 150px;
}
.wzb-mid {
  flex: 2;
  min-width: 300px;
}
</style>
